export enum EditStatus {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOT_PERFORMED = 'NOT_PERFORMED',
    NOT_CHANGED = 'NOT_CHANGED',
}
